// extracted by mini-css-extract-plugin
export default {"categoryRemainder":"Remainder_categoryRemainder__31xAS","categoryRemainderIcon":"Remainder_categoryRemainderIcon__xlZKa"};